export const connectorTypes = [
  "Type 1",
  "Type 2",
  "CCS Type 1",
  "CCS Type 2",
  "CHAdeMO",
  "NACS",
];

export const statusList = [
  "New",
  "Ordered",
  "In-WareHouse",
  "Shipped",
  "Registered",
  "Connected",
  "Commissioned",
  "Installed",
  "Active",
  "RMA"
];

export const chargerType = [
  { label: 'AC', value: 'AC' },
  { label: 'DC', value: 'DC' },
];

export const ocppVersions = ["1.6", "2.0.1"];

export const noOfConnectors = [1, 2, 3, 4, 5, 6, 7, 8];